import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reset } from 'redux-form';
import List from './List';
import Filter from './Filter';
import { loadUpcomingCancellations, exportUpcomingCancellations } from './actions';
import { initialize } from 'redux-form';

class UpcomingCancellations extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleTermSelected = this.handleTermSelected.bind(this);
		this.state = {
			termId: null
		};
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		if (filter && filter.termId) {
			this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
			this.props.initializeFilter(filter);
			this.setState({ termId: filter.termId });
		}
	}

	handleTermSelected(termId) {
		// trigger filter on initial load when Active Term is selected by default in the dropdown
		if (this.state.termId === null) {
			const { filter = {} } = this.props.pagination;
			if (!filter.termId) {
				filter.termId = termId;
				this.props.initializeFilter(filter);
			}

			this.loadData({ ...this.props.pagination, filter });
		}
		this.setState({ termId });
	}

	handleFilterSubmit(options) {
		const { isExport, ...filter } = options;
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (isExport)
			this.exportData(filter);
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		const { loadReport } = this.props;
		loadReport({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	exportData(filter) {
		this.props.exportReport(filter);
	}

	render() {
		const { data } = this.props;

		return (
			<div>
				<Filter
					onSubmit={this.handleFilterSubmit}
					onTermSelected={this.handleTermSelected}
					loading={this.props.pagination.loading || this.props.export.loading}
				/>
				<List
					data={data}
					onFetchData={this.handleListEvent}
					{...this.props.pagination}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {

	const {
		pagination,
		exports,
		entities: { upcomingCancellations }
	} = state;

	const upcomingCancellationsPagination = pagination.upcomingCancellations.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const upcomingCancellationsExport = exports.upcomingCancellations.all || {};

	return {
		data: upcomingCancellationsPagination.ids.map(id => upcomingCancellations[id]),
		pagination: upcomingCancellationsPagination,
		export: upcomingCancellationsExport
	};
};

const mapDispatchToProps = {
	loadReport: loadUpcomingCancellations,
	exportReport: exportUpcomingCancellations,
	resetFilter: () => reset('upcomingCancellationsFilter'),
	initializeFilter: (data, fields) => initialize('upcomingCancellationsFilter', data, fields)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UpcomingCancellations));